<template>
  <div class="content-edit">

    <el-form ref="form" :model="form" :rules="rules" label-width="130px" size="small">
      <div class="white-container">
        <p class="mb30">基础信息</p>
        <el-form-item label="活动标题" prop="title" style="width: 464px">
          <el-input v-model="form.title" maxlength="14" :disabled="editType==='limited'" placeholder="请输入活动标题，最多不超过14个字" />
        </el-form-item>
        <el-form-item label="报名截止日期" prop="signUpEnd" style="width: 464px">
          <el-date-picker
            v-model="form.signUpEnd"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :disabled="editType==='limited'"
          />
        </el-form-item>
        <el-form-item label="活动日期" prop="activityDate" style="width: 464px">
          <el-date-picker
            v-model="form.activityDate"
            type="daterange"
            range-separator="-"
            start-placeholder="活动开始日期"
            end-placeholder="活动结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :disabled="editType==='limited'"
            @change="handleReceiveTimeChange"
          />
        </el-form-item>
        <el-form-item label="活动介绍" prop="introduction" style="width: 764px">
          <el-input v-model="form.introduction" type="textarea" :autosize="{ minRows: 4,}" :disabled="editType==='limited' && !hasStatus" placeholder="请输入活动介绍" />
        </el-form-item>
        <el-form-item label="活动规则项及免责声明" class="disclaimer" prop="rulesUrl" style="width: 464px">
          <el-input v-model="form.rulesUrl" placeholder="请输入链接" :disabled="editType==='limited'" />
        </el-form-item>
      </div>
      <div class="white-container marginTop plan-select">
        <p class="mb30">关联训练计划</p>
        <el-form-item label="关联训练计划" prop="planIds" style="width: 100%">
          <el-select
            v-model="form.planIds"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remotePlanMethod"
            :disabled="editType==='limited'"
            @input.native="handlePlanInputChange"
            @remove-tag="handleRemoveTag"
            @visible-change="handlePlanInputVisibleChange"
          >
            <!-- slot empty -->
            <template #empty>
              <div class="empty-text">没有查到相关活动</div>
            </template>
            <el-option
              v-for="item in planList"
              :key="item.id"
              :label="item.title + '(' + item.id + ')'"
              :value="item.id"
            >
              <span style="float: left">{{ item.title }}</span>
              <span style="color: #8492a6; font-size: 13px">(ID:{{ item.id }})</span>
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <p class="mb30">关联奖池</p>
        <el-form-item style="width: 100%; margin-left: -130px;">
          <div v-for="(item, index) in form.prizeVOList" :key="index" class="pool-items">
            <div>
              <span>累计</span>
              <el-input-number v-model="item.goal" :min="1" step-strictly style=" margin:0 10px" :disabled="editType==='limited'" />
              <span>天</span>
            </div>
            <div style="margin: 0 50px;">
              <span style="margin-right: 10px;">关联奖池</span>
              <el-select
                v-model="item.name"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="remotePrizeMethod"
                :disabled="editType==='limited'"
                @input.native="handlePlanInputChange"
                @change="handlePrizeChange($event,item,index)"
                @visible-change="handlePrizeInputVisibleChange"
              >
                <!-- slot empty -->
                <template #empty>
                  <div class="empty-text">没有查到相关奖池</div>
                </template>
                <el-option
                  v-for="ele in poolList"
                  :key="ele.id"
                  :value="ele.id"
                >
                  <span style="float: left">{{ ele.name }}</span>
                  <span style="color: #8492a6; font-size: 13px">(ID:{{ ele.id }})</span>
                </el-option>
              </el-select>
            </div>
            <div>
              <el-button type="info" size="small" :disabled="editType==='limited'" @click="handleReset(item,index)">重置</el-button>
              <el-button type="danger" size="small" :disabled="editType==='limited'" @click="handleDelete(item,index)">删除</el-button>
            </div>
          </div>
          <div class="pool-btn-box">
            <el-button class="pool-btn" icon="el-icon-plus" :disabled="editType==='limited'" plain @click="handleAdd">关联奖池</el-button>
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <p class="mb30">EC BANNER</p>
        <el-form-item prop="bannerList" style="width: 100%; margin-left: -130px;">
          <br>
          <div class="ecbanner-content">
            <UploadImage :disabled="editType==='limited'" :img-info="{ name: '', size: 5, width: 1005, height: 503,key: 'ecBannerPicture' }" :custom-style="{ width: '300px', height: '150px' }" :is-line="true" :image-url="form.bannerList.ecBannerPicture" @upload="handleUploadImgChange" />
            <div>
              <span style="margin-right: 10px;">EC BANNER链接</span>
              <el-input v-model="form.bannerList.ecBannerUrl" :disabled="editType==='limited'" style="width: 358px;height:44px" />
            </div>
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <p class="">上传图片</p>
        <el-form-item prop="bannerList" style="width: 100%; margin-left: -50px;">
          <br>
          <div class="uploadImg-wrapper">
            <UploadImage :disabled="editType==='limited'" required :img-info="{ name: '活动详情页头图', size: 5, width: 1125, height: 1125,key: 'activityDetailsPageHeader' }" :image-url="form.bannerList.activityDetailsPageHeader" @upload="handleUploadImgChange" />
            <UploadImage :disabled="editType==='limited' && !hasStatus" required :img-info="{ name: '社群BANNER', size: 5, width: 1005, height: 503,key: 'enterpriseWechatBanner' }" :image-url="form.bannerList.enterpriseWechatBanner" @upload="handleUploadImgChange" />
            <UploadImage :disabled="editType==='limited'" required :img-info="{ name: '小程序分享卡片', size: 2, width: 500, height: 400,key: 'shareCardImage' }" :image-url="form.bannerList.shareCardImage" @upload="handleUploadImgChange" />
            <UploadImage :disabled="editType==='limited'" required :img-info="{ name: '活动长图分享图片', size: 5, width: 849, height: 849,key: 'shareImage' }" :image-url="form.bannerList.shareImage" @upload="handleUploadImgChange" />
            <UploadImage :disabled="editType==='limited' && !hasStatus" required :img-info="{ name: '社群落地页图片', size: 5, width: 750, height: 1448,key: 'communityPhotos' }" :image-url="form.bannerList.communityPhotos" @upload="handleUploadImgChange" />
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop submit-btn-box">
        <el-form-item style="width: 100%; margin-left: -50px;">
          <div class="flex btns">
            <el-button class="btn" type="info" :disabled="editType==='limited' && !hasStatus" @click="handleCancel">取消</el-button>
            <el-button class="btn" type="primary" :disabled="editType==='limited' && !hasStatus" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />

  </div>
</template>
<script>
import Dialog from "@/components/Dialog";
import UploadImage from "../../plan/components/uploadImage.vue";
export default {
  components: { Dialog, UploadImage },

  data() {
    return {
      planList: [],
      poolList: [],
      form: {
        bannerList: {
          activityDetailsPageHeader: "",
          ecBannerPicture: "",
          ecBannerUrl: "",
          enterpriseWechatBanner: "",
          shareCardImage: "",
          shareImage: "",
          communityPhotos: "",
        },
        endDate: "",
        startDate: "",
        activityDate: '',
        introduction: "",
        planIds: [],
        prizePoolInfo: [],
        prizeVOList: [],
        planDetails: [],
        rulesUrl: "",
        signUpEnd: "",
        title: "",
      },
      oriPlanDetails: [],
      oriPoolList: [],
      formDialogShow: false,
      information: {},
      rules: {
        title: [
          { required: true, message: "请输入活动标题", trigger: ["blur"] },
        ],
        activityDate: [
          { required: true, message: "请输入活动标题", trigger: ["blur"] },
        ],
        rulesUrl: [
          { required: true, message: "请输入链接", trigger: ["blur"] },
        ],
        introduction: [
          { required: true, message: "请输入活动介绍", trigger: ["blur"] },
        ],
        signUpEnd: [
          { required: true, message: "请选择报名截止日期", trigger: ["blur"] },
        ],
        planIds: [
          { required: true, message: "请选择关联训练计划", trigger: ["blur"] },
        ],
      },
      editType: '',
      hasStatus: false,
    };
  },
  async created() { },
  mounted() {
    const { query } = this.$route;
    const { id, type } = query;
    if (id && type) {
      this.handleType = type;
      this.oldId = id;
      this.fetchMarketContent();
      if (type === 'edit' && query.status && ([2, 3, 4].includes(+query.status))) {
        this.editType = 'limited';
        this.hasStatus = true;
      }
      if (type === 'preview') {
        this.editType = 'limited';
        this.hasStatus = false;
      }
    } else {
      this.handleType = 'add';
      this.remotePlanMethod('');
      this.remotePrizeMethod('');
    }
  },
  beforeDestroy() { },
  methods: {
    submit() {
      this.$refs.form.validate().then(res => {
        if (res) {
          const { activityDetailsPageHeader, enterpriseWechatBanner, shareCardImage, shareImage, communityPhotos } = this.form.bannerList;
          if (!activityDetailsPageHeader || !enterpriseWechatBanner || !shareCardImage || !shareImage || !communityPhotos) {
            this.$message.error('请上传活动图片');
            return;
          }
          this.formDialogShow = true;
          this.information = {
            operation: "submit",
            icon: "warn",
            subTitle: "是否确认保存编辑的内容？",
          };
        }
      });
    },
    async fetchMarketContent() {
      this.$Api.newCamp.campSetDetails(this.oldId).then(data => {
        data.activityDate = [data.startDate, data.endDate];
        this.form = Object.assign(this.form, data);
        this.remotePlanMethod('');
        this.remotePrizeMethod('');
      });
    },
    // 取消
    handleCancel() {
      this.formDialogShow = true;
      this.information = {
        operation: "cancel",
        icon: "warn",
        subTitle: `是否放弃本次更改，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.form.prizePoolInfo = this.form.prizeVOList.map(item => {
          return { goal: item.goal, poolId: item.id };
        });
        if (this.handleType === 'edit') {
          this.editCampActivity();
        } else {
          this.addCampActivity();
        }
      }
    },
    editCampActivity() {
      this.$Api.newCamp.campSetEdit(this.form).then(data => {
        this.$message.success('编辑成功');
        this.$router.go(-1);
      });
    },
    addCampActivity() {
      if (this.handleType === 'copy') {
        delete this.form.id;
      }
      this.$Api.newCamp.campSetAdd(this.form).then(data => {
        this.$message.success('编辑成功');
        this.$router.go(-1);
      });
    },
    handleReceiveTimeChange(value) {
      console.log('value', value);
      if (value) {
        this.form.startDate = this.$moment(value[0]).format('YYYY-MM-DD HH:mm:ss');
        this.form.endDate = this.$moment(value[1]).format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.form.startDate = '';
        this.form.endDate = '';
      }
    },
    handleUploadImgChange(data) {
      this.form.bannerList[data.key] = data.url;
    },
    remotePlanMethod(query) {
      this.$Api.newCamp.campSetPlanSelect({ id: query }).then(data => {
        this.planList = data;
        if (this.form.planDetails && !query) {
          if (!this.oriPlanDetails.length) {
            this.oriPlanDetails = this.form.planDetails.map(item => {
              return {
                ...item,
                isSelected: true,
              };
            });
          }
          const newPlanDetails = this.oriPlanDetails.filter(item => item.isSelected);
          this.planList.push(...this.form.planDetails);
          this.planList = [...this.planList];
          this.form.planIds = [...new Set([...this.form.planIds, ...newPlanDetails.map(item => item.id)])];
        }
      });
    },
    remotePrizeMethod(query) {
      this.$Api.newCamp.campSetPrizeSelect({ id: query }).then(data => {
        /* 每次要过滤掉已关联的 */
        data = data.map(item => {
          return {
            ...item,
            isSelected: false,
          };
        });
        this.poolList = data;
        if (this.form.prizeVOList && !query) {
          if (!this.oriPoolList.length) {
            this.oriPoolList = this.form.prizeVOList.map(item => {
              return {
                id: item.id,
                name: item.name,
                isSelected: true,
              };
            });
            this.oriPoolList = [...this.oriPoolList, ...data];
          }
          this.poolList = this.oriPoolList.filter(item => !item.isSelected);
        }
      });
    },
    handlePlanInputChange(e) {
      e.target.value = e.target.value.replace(/^(0+)|[^\d]+/g, '').replace(/\d{8,}/, (match) => match.slice(0, 8));
      if (!e.target.value) {
        // 阻止默认事件
        e.preventDefault();
      }
    },
    handleRemoveTag(e) {
      this.oriPlanDetails.forEach(item => {
        if (item.id === e) {
          item.isSelected = false;
        }
      });
      this.oriPlanDetails = [...this.oriPlanDetails];
      this.$refs.form.validateField('planIds');
    },
    handlePlanInputVisibleChange(isOpen) {
      !isOpen && this.remotePlanMethod('');
      /* 校验 form.planIds 使用this.$refs.form.validate */
      !isOpen && this.$refs.form.validateField('planIds');
    },
    handlePrizeInputVisibleChange(isOpen) {
      !isOpen && this.remotePrizeMethod('');
    },
    handlePrizeChange(poolId, item, index) {
      const target = this.oriPoolList.find(item => item.id === poolId);
      const oldItem = this.form.prizeVOList[index];
      this.form.prizeVOList[index] = { ...oldItem, ...target };
      this.form.prizeVOList = [...this.form.prizeVOList];
      const hasSelectedList = this.form.prizeVOList.map(item => item.id);
      this.oriPoolList = this.oriPoolList.map(item => {
        return {
          ...item,
          isSelected: !!hasSelectedList.includes(item.id),
        };
      });
      this.poolList = this.oriPoolList.filter(item => !item.isSelected);
    },
    handleReset(item, index) {
      if (!item.id) return;
      this.form.prizeVOList[index] = { name: '', goal: null, id: null };
      this.oriPoolList.forEach(ele => {
        if (item.id === ele.id) {
          ele.isSelected = false;
        }
      });
      this.form.prizeVOList = [...this.form.prizeVOList];
      this.oriPoolList = [...this.oriPoolList];
      this.poolList = this.oriPoolList.filter(item => !item.isSelected);
    },
    handleDelete(item, index) {
      this.form.prizeVOList.splice(index, 1);
      this.form.prizeVOList = [...this.form.prizeVOList];
      if (item.id) {
        this.oriPoolList.forEach(ele => {
          if (item.id === ele.id) {
            ele.isSelected = false;
          }
        });
        this.oriPoolList = [...this.oriPoolList];
        this.poolList = this.oriPoolList.filter(item => !item.isSelected);
      }
    },
    handleAdd() {
      if (this.editType === 'limited') return;
      this.form.prizeVOList.push({ name: '', goal: null, id: null });
      this.form.prizeVOList = [...this.form.prizeVOList];
    },
  },
};
</script>
<style lang="less" scoped>
.mb30{
  margin-bottom: 30px;
}
.content-edit {
  .btns {
    align-items: center;
    justify-content: center;
    .btn{
      width: 120px;
      height: 40px;
    }
  }
  .marginTop {
    margin-top: 30px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
}
.white-container{
  padding-bottom: 1px;
}
.pool-items{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-height: 104px;
  padding: 0 80px;
  background-color: #f7f7f7;
  margin-bottom: 30px;
  div{
    display: flex;
    align-items: center;
  }
}
.pool-btn-box{
  display: flex;
  justify-content: center;
  .pool-btn{
    width: 150px;
    height: 34px;
    border-style: dashed;
  }
}
.uploadImg-wrapper{
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin-left: -76px;
}
.ecbanner-content{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 50px;
}
/deep/ .disclaimer .el-form-item__label {
  line-height: 1.4;
}
.empty-text{
  color: #999999;
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
}
/deep/ .plan-select .el-select__tags .el-tag {
  width: auto !important;
}
</style>
